import React from "react";
import ReCAPTCHA from "react-google-recaptcha";

const RecaptchaPayment = ({ recaptchaRef, formik }) => {
  return (
    <ReCAPTCHA
      ref={recaptchaRef}
      sitekey={process.env.REACT_APP_SITE_KEY}
      onChange={(value) => {
        formik.setFieldValue("captchaValue", value || "");
      }}
    />
  );
};

export default RecaptchaPayment;
